// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressVerificationForm_container__OpDZA","headline":"AddressVerificationForm_headline__EXL8O"};